export default __webpack_public_path__ + "static/media/nodata.5798f2da.svg";